import { render, staticRenderFns } from "./courseEvaluationModal.vue?vue&type=template&id=cef474b2&scoped=true&"
import script from "./courseEvaluationModal.vue?vue&type=script&lang=js&"
export * from "./courseEvaluationModal.vue?vue&type=script&lang=js&"
import style0 from "./courseEvaluationModal.vue?vue&type=style&index=0&id=cef474b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef474b2",
  null
  
)

export default component.exports